import request from '@/utils/request'

// 获取轮播数据
export function getbannerList(query) {
  return request({
    url: '/front/bannerList',
    method: 'get',
    params: query
  })
}

// 获取友情链接数据
export function getfriendList(query) {
  return request({
    url: '/front/friendLinkList',
    method: 'get',
    params: query
  })
}

// 获取文章列表数据
export function getshowList(query) {
  return request({
    url: '/front/getArticleList',
    method: 'get',
    params: query
  })
}

// 获取部门信息及员工数据
export function getpersonList(query) {
  return request({
    url: '/front/getDepartmentMemberList',
    method: 'get',
    params: query
  })
}
// 获取时间与地址
export function getTimaddr(query) {
  return request({
    url: '/front/getWebInfo',
    method: 'get',
    params: query
  })
}

// 搜索接口
export function getSearch(query) {
  return request({
    url: '/front/search',
    method: 'get',
    params: query
  })
}

// 获取展览信息
export function getExhibitionsInfo(query) {
  return request({
    url: '/front/getExhibitionsInfo',
    method: 'get',
    params: query
  })
}